import { useState } from 'react';
import { useGetComponentTypes, useGetSections } from 'src/hooks';
import { useGetAllLayoutType } from 'src/hooks/api/layoutTypes/useGetAllLayoutTypes';

export const useAddComponentPage = () => {
  const [layoutType, setLayoutType] = useState(0);
  const [componentType, setComponentType] = useState(0);

  const {
    data: layoutTypes = [],
    isLoading: isLoadingLayoutTypes,
    error: errorLoadingLayoutTypes,
  } = useGetAllLayoutType();

  const {
    data: componentTypes = [],
    isLoading: isLoadingComponentTypes,
    error: errorLoadingComponentTypes,
  } = useGetComponentTypes([`layout_type_id=${layoutType}`], {
    enabled: Boolean(layoutType),
  });

  const {
    data: sections = [],
    isLoading: isLoadingSections,
    error: errorLoadingSections,
  } = useGetSections(
    [`component_type_id=${componentType}`, `layout_type_id=${layoutType}`],
    Boolean(componentType) && Boolean(layoutType),
  );

  return {
    isLoadingLayoutTypes,
    isLoadingComponentTypes,
    isLoadingSections,
    errorLoadingLayoutTypes,
    errorLoadingComponentTypes,
    errorLoadingSections,
    layoutTypes,
    componentTypes,
    sections,
    layoutTypeState: layoutType,
    componentTypeState: componentType,
    setLayoutType,
    setComponentType,
  };
};
